import React, {useContext} from "react";
import HelpComponent from "components/HelpComponent";
import TextInput from "components/TextInput";
import FormTranslationContext from "context/FormTranslationContext";

function NoticeTextInput
({
     id,
     label,
     formikProps,
     required,
     multiline,
     disabled
 }) {
    const {formTr, formTip} = useContext(FormTranslationContext)
    const tip = formTip(label ? label : id);


    const input = <TextInput
        id={id}
        label={formTr(label ? label : id)}
        formikProps={formikProps}
        required={required}
        multiline={multiline}
        skipCheckTouched
        disabled={disabled}
    />

    if (tip)
        return <HelpComponent text={tip}>
            {input}
        </HelpComponent>
    return input;


}

export default NoticeTextInput;